module.exports = __webpack_public_path__ + "img/quoteBottomRight.11887d58.svg";